import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalendarRoutingModule } from './calendar-routing.module';
import { CalendarViewComponent } from './calendar-view/calendar-view.component';

import { FullCalendarModule } from '@fullcalendar/angular'; // the main connector. must go first
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import interactionPlugin from '@fullcalendar/interaction';
import { CalendarService } from './_services/calendar.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CalendarInterceptor } from './_services/calendar-interceptor.interceptor'; // a plugin
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TaskEffects, tasksReducer } from 'src/app/core/timeline';
import { CreateTaskComponent } from './create-task/create-task.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { PartialsModule } from '../../partials/partials.module';
import { NgxPermissionsModule, NgxPermissionsRestrictStubModule } from 'ngx-permissions';
import { ChooseTemplateDialogComponent } from './choose-template/choose-template.dialog.component';
import { FollowUpDialogComponent } from '../follow-up/follow-up-dialog/follow-up-dialog.component';
import { NewAttemptDialogComponent } from '../follow-up/new-attempt-dialog/new-attempt-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CreateWorkflowDialogComponent } from '../workflow/create-workflow-dialog/create-workflow-dialog.component';
import { AttemptListComponent } from '../follow-up/attempt-list/attempt-list.component';
import { MatChipsModule } from '@angular/material/chips';
import { SelectEntitiesDialogComponent } from '../../partials/content/general/select-entities-dialog/select-entities-dialog.component';
import { CancelTaskDialogComponent } from './cancel-task-dialog/cancel-task-dialog.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InlineSVGModule } from 'ng-inline-svg';
import { CoreModule } from '../../../core/core.module';
import { SendMessageDialogComponent } from './send-message-dialog/send-message.dialog.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { QuillModule } from 'ngx-quill';
import { FormsTemplatesModule } from '../forms-templates/forms-templates.module';
import { FormioModule } from 'angular-formio';
import { TaskDueDateLabelFormatPipe } from './pipes';
import { TaskVariableAreaViewComponent } from './task-variable-area-view/task-variable-area-view.component';
import { FormatTaskEntitiesComponent } from './format-task-entities/format-task-entities.component';
import { ShareTaskAttachmentComponent } from './share-task-attachment/share-task-attachment.component';
import { WarnCreateDuplicateTaskComponent } from './warn-create-duplicate-task/warn-create-duplicate-task.component';
import { TaskSkeletonComponent } from './task-skeleton/task-skeleton.component';
import { TaskAgentHitlComponent } from './task-agent-hitl/task-agent-hitl.component';
import { BridgePayModule } from 'src/app/core/bridge-pay/bridgepay.module';
import { MatBadgeModule } from '@angular/material/badge';

FullCalendarModule.registerPlugins([
  // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin,
]);

@NgModule({
  declarations: [
    CalendarViewComponent,
    CreateTaskComponent,
    WarnCreateDuplicateTaskComponent,
    TaskVariableAreaViewComponent,
    FormatTaskEntitiesComponent,
    ShareTaskAttachmentComponent,
    TaskDueDateLabelFormatPipe,
    ChooseTemplateDialogComponent,
    CancelTaskDialogComponent,
    SendMessageDialogComponent,
    TaskSkeletonComponent,
    TaskAgentHitlComponent,
  ],
  imports: [
    CommonModule,
    CalendarRoutingModule,
    FullCalendarModule,
    StoreModule.forFeature('tasks', tasksReducer),
    EffectsModule.forFeature([TaskEffects]),
    PerfectScrollbarModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatRadioModule,
    TranslateModule.forChild(),
    PartialsModule,
    MatSelectModule,
    MatCheckboxModule,
    NgxPermissionsModule.forChild(),
    MatTooltipModule,
    MatDatepickerModule,
    MatChipsModule,
    NgbModule,
    InlineSVGModule,
    CoreModule,
    MatButtonToggleModule,
    QuillModule,
    FormsTemplatesModule,
    NgxPermissionsRestrictStubModule,
    FormioModule,
    BridgePayModule,
    MatBadgeModule,
  ],
  providers: [
    CalendarService,
    { provide: HTTP_INTERCEPTORS, useClass: CalendarInterceptor, multi: true },
  ],
  entryComponents: [
    CreateWorkflowDialogComponent,
    CreateTaskComponent,
    WarnCreateDuplicateTaskComponent,
    ShareTaskAttachmentComponent,
    FollowUpDialogComponent,
    NewAttemptDialogComponent,
    AttemptListComponent,
    SelectEntitiesDialogComponent,
    CancelTaskDialogComponent,
    SendMessageDialogComponent,
    TaskSkeletonComponent,
  ],
  exports: [CreateTaskComponent, TaskSkeletonComponent],
})
export class CalendarModule {}
